export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9544.447746db.jpg";